import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../dietAction';
import fetchApi from "./fetchApi";

function fetchDietAction() {
  return fetchApi('/v1/fc_api/diet_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchDietAction;
